export class ObjectUtil {
    // Reflect check non-enumerable properties (It is better than Lodash's _.isEmpty())
    static isObjectEmpty(object: Record<string, unknown>): boolean {
        return object !== null && object !== undefined && Reflect.ownKeys(object).length === 0;
    }
}
